const imgAPI = {
  landing: [
    "/images/landing/broneeringud.png",
    "/images/landing/kalender.png",
    "/images/landing/kliendid.png",
    "/images/landing/1280x1024.png",
  ],
  avatar: [
    "/images/avatars/pp_girl.svg",
    "/images/avatars/pp_girl2.svg",
    "/images/avatars/pp_girl3.svg",
    "/images/avatars/pp_girl4.svg",
    "/images/avatars/pp_girl5.svg",
    "/images/avatars/pp_girl.svg",
    "/images/avatars/pp_boy.svg",
    "/images/avatars/pp_boy2.svg",
    "/images/avatars/pp_boy3.svg",
    "/images/avatars/pp_boy4.svg",
    "/images/avatars/pp_boy5.svg",
  ],
  photo: [
    "https://via.placeholder.com/675x900/e1ad92/fff",
    "https://via.placeholder.com/967x725/ea6d6d/fff",
    "https://via.placeholder.com/1280x849/ea6db7/fff",
    "https://via.placeholder.com/967x725/bb6dea/fff",
    "https://via.placeholder.com/1048x701/6d6fea/fff",
    "https://via.placeholder.com/1050x700/6dc0ea/fff",
    "https://via.placeholder.com/970x725/6deaa6/fff",
    "https://via.placeholder.com/1051x700/b8de27/fff",
    "https://via.placeholder.com/1051x701/de9f27/fff",
    "https://via.placeholder.com/1050x700/ef4545/fff",
    "https://via.placeholder.com/1050x700/ffc4c4/757575",
    "https://via.placeholder.com/640x447/fdffc4/757575",
    "https://via.placeholder.com/1280x851/c4ffd7/757575",
    "https://via.placeholder.com/640x425/c4cdff/757575",
  ],
  saas: [
    "https://via.placeholder.com/1000x625/f2c9ff/757575", //0
    "https://via.placeholder.com/1472x637/5abce4/FFFFFF", //1
    "https://via.placeholder.com/1000x625/e6f8ff/757575", //2
    "/images/saas/app-counter.png", //3
    "https://via.placeholder.com/1000x680/b44fd4/FFFFFF", //4
    "https://via.placeholder.com/1000x680/00a7e8/FFFFFF", //8
    "https://via.placeholder.com/1000x680/e91e63/FFFFFF", //9
    "/images/saas/desktop_illustration.png", //7
    "https://res.cloudinary.com/imajin/image/upload/v1573808069/saas/desktop_illustration_ykznmj.png", //8
    "/images/bookus/full.png", //9
    "https://res.cloudinary.com/imajin/image/upload/v1571261783/saas/app-screen1_nddmrv.jpg", //10
    "https://res.cloudinary.com/imajin/image/upload/v1571261871/saas/app-chart_exua6w.jpg", //11
    "https://res.cloudinary.com/imajin/image/upload/v1571261793/saas/app-screen2_rt1jqc.jpg", //12
    "", //13
    "https://res.cloudinary.com/imajin/image/upload/v1571261795/saas/app-screen3_mgnq5w.jpg", //14
    "https://res.cloudinary.com/imajin/image/upload/v1571261794/saas/app-screen4_agrclh.jpg", //15
    "https://res.cloudinary.com/imajin/image/upload/v1571261794/saas/app-screen5_w37qjo.jpg", //15
  ],
  mobile: [
    "/images/mobile/mobile_banner.png",
    "/images/mobile/widget-top.png",
    "/images/mobile/widget-left.png",
    "/images/mobile/widget-right.png",
    "/images/mobile/mobile_feature.png",
    "/images/mobile/mobile_feature2.png",
    "https://via.placeholder.com/536x302/fbd2ff/757575",
    "https://via.placeholder.com/518x1120/fbd2ff/757575",
    "https://via.placeholder.com/518x1120/d2ffff/757575",
    "https://via.placeholder.com/518x1120/fbd2ff/757575",
    "https://via.placeholder.com/518x1120/d2ffff/757575",
    "https://via.placeholder.com/518x1120/fbd2ff/757575",
    "https://via.placeholder.com/518x1120/d2ffff/757575",
    "https://via.placeholder.com/518x1120/fbd2ff/757575",
    "/images/mobile/widget_screen1.png",
    "/images/mobile/widget_screen2.png",
    "/images/mobile/widget_screen3.png",
    "/images/mobile/widget_screen4.png",
    "/images/mobile/widget_screen5.png",
    "/images/mobile/widget_screen6.png",
    "/images/mobile/widget_screen7.png",
    "",
  ],
};

export default imgAPI;
